import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationEN from './locales/en.json';
import translationNL from './locales/nl.json';
import translationDE from './locales/de.json';
import translationFR from './locales/fr.json';
import translationES from './locales/es.json';
import translationZH from './locales/zh.json';

const resources = {
  en: { translation: translationEN },
  nl: { translation: translationNL },
  de: { translation: translationDE },
  fr: { translation: translationFR },
  es: { translation: translationES },
  zh: { translation: translationZH }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'nl',
    supportedLngs: ['nl', 'en', 'de', 'fr', 'es', 'zh'],
    nonExplicitSupportedLngs: true,
    load: 'languageOnly',
    cleanCode: true,
    debug: false,
    
    detection: {
      // The URL decides (?lang=), then an explicit earlier choice, then <html lang> (nl on the bare URL).
      // No browser-language auto-switch: one URL must not render in different languages for different visitors.
      order: ['querystring', 'localStorage', 'htmlTag'],
      lookupQuerystring: 'lang',
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
      convertDetectedLanguage: (lng) => (lng || 'en').replace('_', '-').split(/[-@.]/)[0]
    },

    interpolation: {
      escapeValue: false
    }
  });

const syncHtmlLang = (lng) => {
  if (typeof document !== 'undefined') {
    document.documentElement.lang = (lng || 'nl').split('-')[0];
  }
};

syncHtmlLang(i18n.resolvedLanguage || i18n.language);
i18n.on('languageChanged', syncHtmlLang);

/* Keep the address bar in step with the language on public pages: ?lang=xx (none for the default, Dutch). */
const APP_PREFIXES = ['/dashboard', '/admin', '/payment', '/reset-password', '/verify-email', '/magic-login', '/google-ads'];
i18n.on('languageChanged', (lng) => {
  if (typeof window === 'undefined') return;
  const { pathname, search, hash } = window.location;
  if (APP_PREFIXES.some((p) => pathname.startsWith(p))) return;
  const code = (lng || 'nl').split('-')[0];
  const params = new URLSearchParams(search);
  if (code === 'nl') params.delete('lang');
  else params.set('lang', code);
  const qs = params.toString();
  const next = `${pathname}${qs ? `?${qs}` : ''}${hash}`;
  if (next !== `${pathname}${search}${hash}`) window.history.replaceState(window.history.state, '', next);
});

export default i18n;